import React, { useEffect, useState, useCallback } from 'react';
import API from '../../api';
import { Activity, RefreshCw, CheckCircle2, XCircle, Loader2 } from 'lucide-react';

export default function HealthTab() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const r = await API.get('/api/admin/health/diagnostic');
      setData(r.data);
    } catch (e) {
      setData({ error: e.response?.data?.detail || e.message });
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <div className="space-y-4" data-testid="health-tab">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Activity className="text-primary" size={20} />
          <h2 className="text-lg font-bold">Diagnostica Sistema</h2>
          {data && !data.error && (
            <span className={`px-2 py-0.5 text-xs font-bold rounded ${data.overall_ok ? 'bg-green-100 text-green-700' : 'bg-amber-100 text-amber-700'}`}>
              {data.overall_ok ? '✓ Tutto OK' : '⚠ Attenzione'}
            </span>
          )}
        </div>
        <button onClick={load} disabled={loading}
          className="inline-flex items-center gap-1 px-3 py-1.5 bg-slate-100 hover:bg-slate-200 rounded text-sm font-bold disabled:opacity-50"
          data-testid="health-refresh">
          {loading ? <Loader2 size={14} className="animate-spin" /> : <RefreshCw size={14} />} Aggiorna
        </button>
      </div>

      {data?.error && (
        <div className="p-3 bg-red-50 text-red-700 rounded">{data.error}</div>
      )}

      {data?.checks && (
        <div className="space-y-2">
          {data.checks.map((c, i) => (
            <div key={i} className={`flex items-start gap-3 p-3 rounded border ${c.ok ? 'bg-green-50/50 border-green-200' : 'bg-amber-50 border-amber-200'}`} data-testid={`health-check-${c.name}`}>
              {c.ok ? <CheckCircle2 className="text-green-600 flex-shrink-0 mt-0.5" size={18} /> : <XCircle className="text-amber-600 flex-shrink-0 mt-0.5" size={18} />}
              <div className="flex-1">
                <p className="font-bold text-sm text-slate-800">{c.name}</p>
                <p className="text-xs text-slate-600 mt-0.5">{c.detail}</p>
              </div>
            </div>
          ))}
        </div>
      )}

      {data?.timestamp && (
        <p className="text-xs text-slate-400">Ultima verifica: {new Date(data.timestamp).toLocaleString('it-IT')}</p>
      )}
    </div>
  );
}
